export default __webpack_public_path__ + "static/O0016-32a1573f559b5c8ea19a9e7c7d21c01c.png";